import { Box, Container } from "../MuiGenerals";
import PageConfigProvider from "src/features/PageConfigProvider";
import { ExportButtonProps } from "src/features/PageConfigProvider/components/ExportButton";
import { customSx } from "src/utils/styling";

function FilterTemplate<GetListRes>({
  exportConfig,
  renderFields,
  extraButtons,
}: {
  renderFields: () => React.ReactNode;
  exportConfig?: ExportButtonProps<GetListRes>;
  extraButtons?: React.ReactNode;
}) {
  return (
    <>
      <Box sx={customSx.filterCmdBar}>
        {extraButtons}
        {exportConfig && <PageConfigProvider.ExportButton {...exportConfig} />}
      </Box>
      <Container disableGutters maxWidth={false}>
        <Box sx={customSx.gridFilter} className="gridFilter">
          {renderFields()}
        </Box>
        <PageConfigProvider.SearchAndResetBox />
      </Container>
    </>
  );
}

export default FilterTemplate;
